<template>
  <main class="not-found">
    <p class="protocol-label">404</p>
    <h1>Page not found</h1>
    <router-link class="primary-action" :to="{ name: 'SignIn' }">Return to sign in</router-link>
  </main>
</template>
